// extracted by mini-css-extract-plugin
export default {"root":"Status_root__6nhpy","state0":"Status_state0__ey51H","state1":"Status_state1__cRBTk","state2":"Status_state2__NqYeO"};